import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useImposter, useIsDesktop } from 'Hooks';
import { PurpleAlert } from 'Images';
import { scrollToTop } from 'Utils/scrollToTop';
import { useEffect } from 'react';

export const RepAlert = () => {
  const imposter = useImposter();

  const dictionary = useDictionary(Dictionary, DICTIONARY.Lawyers);
  const isDesktop = useIsDesktop();

  useEffect(() => {
    setTimeout(() => {
      scrollToTop();
    }, 0);
  }, []);

  return isDesktop ? (
    <Stack
      role='alert'
      direction='row'
      sx={{
        padding: '8px',
        gap: '8px',
        bgcolor: '#F4E4FF',
        border: '1px solid #B7CCFF',
        borderRadius: '12px',
        p: '24px',
        mb: '12px',
      }}
    >
      <Avatar sx={{ width: '24px', height: '24px' }} alt='' src={PurpleAlert} />
      <Stack>
        <Typography variant='body3'>{dictionary.repFor}</Typography>
        <Stack
          direction='row'
          sx={{
            gap: '15px',
            alignItems: 'flex-end',
          }}
        >
          <Typography variant='h5'>{`${imposter.fakeUser.firstName} ${imposter.fakeUser.lastName}`}</Typography>
          <Typography variant='body3'>{`${dictionary.idNumberWithColon} ${imposter.fakeUser.israeliId} | ${dictionary.toPreformAction}`}</Typography>
        </Stack>
      </Stack>
    </Stack>
  ) : (
    <Stack
      role='alert'
      direction='row'
      sx={{
        padding: '8px',
        mb: '24px',
        gap: '8px',
        bgcolor: '#F4E4FF',
        border: '1px solid #B7CCFF',
        borderRadius: '12px',
        p: '14px',
      }}
    >
      <Avatar sx={{ width: '24px', height: '24px' }} alt='' src={PurpleAlert} />
      <Stack>
        <Typography variant='body3'>{dictionary.repFor}</Typography>
        <Stack
          direction='row'
          sx={{
            gap: '8px',
          }}
        >
          <Typography variant='h5'>{`${imposter.fakeUser.firstName} ${imposter.fakeUser.lastName}`}</Typography>
          <Typography variant='body3'>{'|'}</Typography>
          <Typography variant='body3'>{`${dictionary.idNumberWithColon} ${imposter.fakeUser.israeliId}`}</Typography>
        </Stack>
        <Typography variant='body3'>{`${dictionary.toPreformAction}`}</Typography>
      </Stack>
    </Stack>
  );
};
